import classnames from 'classnames';
import './cardBody.scss';

const CardBody = ({ children, ...customProps }) => {
  const styles = classnames('card-body', [customProps.className]);

  return (
    <div {...customProps} className={styles}>
      {children}
    </div>
  );
};

export default CardBody;
